<template>
  <div class="special-funds">
    <div style="height: 3rem;width:90%;margin: 0 5%; display: flex;align-items: center;flex-direction: row;justify-content: space-between;">
      <h2 class="home-item-title">{{ title }}</h2>
      <div class="btn-more" style="height: 1.8rem;line-height: 1.8rem;border-radius: 1.3rem;font-size:1rem" @click="toMore">{{ $t('ViewMore') }}</div>
    </div>
    <div style="margin-top: 1rem;width: 100%;">
      <slot name="content">

      </slot>
    </div>
    <!-- <div style="height: 4rem;width:90%;margin: 0 5%; display: flex;align-items: center;justify-content: center;">
      <div v-if="screenWidth<=540" class="btn-more" style="height: 3rem;line-height: 3rem;border-radius: 1.5rem;font-size:1.3rem" @click="toMore">{{ $t('ViewMore') }}</div>
    </div> -->
    
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['themeColor', 'screenWidth']),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    toMorwUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      funds: [
        { name: '萨马兰奇全球航海运动基金', image: 'path/to/image1.jpg' },
        { name: '5100西藏教育发展专项基金', image: 'path/to/image2.jpg' },
        { name: '萨马兰奇·亚瑟士向阳基金', image: 'path/to/image3.jpg' },
        { name: '萨马兰奇全球马术发展基金', image: 'path/to/image4.jpg' },
      ],
    };
  },
  methods: {
    toMore() {
      this.$router.push({ path: this.toMorwUrl });
    }
  },
};
</script>

<style scoped>
.special-funds {
  position: relative;
  width: 100%;
  padding:3rem 0;
}

.swiper-slide img {
  width: 100%;
  border-radius: 8px;
}

.caption {
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
}

.el-button {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
.home-item-title{
  font-size: 2.2rem;
}

</style>